// assets
import {
  IconDashboard,
  IconDeviceAnalytics,
  IconKeyboard,
  IconEye,
} from "@tabler/icons";

// constant
const icons = {
  IconDashboard,
  IconDeviceAnalytics,
  IconKeyboard,
  IconEye,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  title: "แดชบอร์ด",
  type: "group",
  children: [
    {
      id: "smarttyping",
      title: "ภาพรวม SmartTyping",
      type: "item",
      url: "/dashboard/smarttyping",
      icon: icons.IconKeyboard,
      breadcrumbs: false,
    },
    {
      id: "default",
      title: "แดชบอร์ดหลัก",
      type: "item",
      url: "/dashboard/default",
      icon: icons.IconDashboard,
      breadcrumbs: false,
    },
    {
      id: "analytics",
      title: "วิเคราะห์ข้อมูลการเงิน",
      type: "item",
      url: "/dashboard/analytics",
      icon: icons.IconDeviceAnalytics,
      breadcrumbs: false,
    },
    {
      id: "visitors",
      title: "สถิติผู้เข้าชม",
      type: "item",
      url: "/dashboard/visitors",
      icon: icons.IconEye,
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
